import axios from 'axios';
import AppConfig from '@/plugins/config/AppConfig';
import { authTokenInterceptor } from '@/helpers/axiosHelpers';

const { env } = AppConfig.load();
const BASE_URL = `https://us-central1-skwad-${env}.cloudfunctions.net/api`;
// Use this and comment out BASE_URL above when using firebase cloud-functions emulator.
// const BASE_URL = 'https://skwad-functions.ngrok.io/skwad-local/us-central1/api';

axios.defaults.baseURL = BASE_URL;
axios.interceptors.request.use(authTokenInterceptor);

const routes = {
  slack: {
    connect: '/slack/connect',
    disconnect: '/slack/disconnect',
    joinChannel: '/slack/join-channel',
    updateMessage: '/slack/update-message',
  },
  stripe: {
    customer: '/stripe/customer',
    subscription: '/stripe/subscription',
    setupIntent: '/stripe/setup-intent',
    subscriptionItem: '/stripe/subscription-item',
  },
};

// Slack
export function connectSlackWorkspace(code) {
  return axios.post(routes.slack.connect, { code });
}

export function disconnectSlackWorkspace(accessToken) {
  return axios.post(routes.slack.disconnect, { accessToken });
}

export function joinSlackChannel(accessToken, channelId) {
  return axios.post(routes.slack.joinChannel, { accessToken, channelId });
}

export function updateSlackMessage(accessToken, channelId, ts, messageText) {
  return axios.post(routes.slack.updateMessage, {
    accessToken, channelId, ts, messageText,
  });
}

// Customer Endpoints
export function getStripeCustomer(customerId) {
  return axios.get(`${routes.stripe.customer}/${customerId}`);
}

export function createStripeCustomer(data) {
  return axios.post(routes.stripe.customer, data);
}

export function updateStripeCustomer(data) {
  return axios.patch(routes.stripe.customer, data);
}

// Subscription Endpoints
export function getStripeSubscription(subscriptionId) {
  return axios.get(`${routes.stripe.subscription}/${subscriptionId}`);
}

export function createStripeSubscription(data) {
  return axios.post(routes.stripe.subscription, data);
}

export function updateStripeSubscription(data) {
  return axios.patch(routes.stripe.subscription, data);
}

// Setup Intent Endpoints
export function createStripeSetupIntent(data) {
  return axios.post(routes.stripe.setupIntent, data);
}

// Subscription Items Endpoints
export function updateStripeSubscriptionItemById(data) {
  return axios.patch(routes.stripe.subscriptionItem, data);
}

export const workspace = {
  create: payload => axios.post('/workspaces/', payload),
};

export const invitation = {
  accept: (invitationId, payload) => axios.patch(`/invitations/accept/${invitationId}`, payload),
};
